import { render, staticRenderFns } from "./EntrustedDataTab.vue?vue&type=template&id=0a135330&scoped=true"
import script from "./EntrustedDataTab.vue?vue&type=script&lang=js"
export * from "./EntrustedDataTab.vue?vue&type=script&lang=js"
import style0 from "./EntrustedDataTab.vue?vue&type=style&index=0&id=0a135330&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a135330",
  null
  
)

export default component.exports